// import {useCallback} from 'react';
import { useCallback } from 'react'
import { useAppSelector } from '../store/hooks'
import { getTextsState } from '../store/appSlice'

// TODO: Change this to a named union type of string constants to reduce some
// code duplication.
//
// TODO: Enforce this enum as the only argument to TextGetter instead of
// multiple strings. This will allow us to easily access a list of text symbol
// ids that are actually in use in the GUI. Then do the same on the server-side.
export enum TextId {
  __TEXTS_ARE_INITIALIZED__ = '__TEXTS_ARE_INITIALIZED__', // A temporary way to check if texts are initialized yet.
  ACCOUNT_DELETE_MESSAGE = 'ACCOUNT_DELETE_MESSAGE',
  ACCOUNT_TEXT_LOGOUT = 'ACCOUNT_TEXT_LOGOUT',
  ACTION_BROWSE_FILES = 'ACTION_BROWSE_FILES',
  ACTION_LABEL_ACCEPT = 'ACTION_LABEL_ACCEPT',
  ACTION_LABEL_BACK_CONFIGURATION = 'ACTION_LABEL_BACK_CONFIGURATION',
  ACTION_LABEL_CONFIGURE_TRUCK = 'ACTION_LABEL_CONFIGURE_TRUCK',
  ACTION_LABEL_DELETE_ACCOUNT = 'ACTION_LABEL_DELETE_ACCOUNT',
  ACTION_LABEL_EXPLORE_DETAILS = 'ACTION_LABEL_EXPLORE_DETAILS',
  ACTION_LABEL_GET_CONSULTATION = 'ACTION_LABEL_GET_CONSULTATION',
  ACTION_LABEL_MY_ACCOUNT = 'ACTION_LABEL_MY_ACCOUNT',
  ACTION_LABEL_MY_GARAGE = 'ACTION_LABEL_MY_GARAGE',
  ACTION_LABEL_NEW_CONFIGURATION = 'ACTION_LABEL_NEW_CONFIGURATION',
  ACTION_LABEL_OVERVIEW = 'ACTION_LABEL_OVERVIEW',
  ACTION_LABEL_PREVIOUS = 'ACTION_LABEL_PREVIOUS',
  ACTION_LABEL_QUICK_START = 'ACTION_LABEL_QUICK_START',
  ACTION_LABEL_RESTART = 'ACTION_LABEL_RESTART',
  ACTION_LABEL_SKIP = 'ACTION_LABEL_SKIP',
  ACTION_LABEL_START_OVER = 'ACTION_LABEL_START_OVER',
  ACTION_LABEL_VIEW_ALL_OPTIONS = 'ACTION_LABEL_VIEW_ALL_OPTIONS',
  ACTION_LABEL_VIEW_LESS = 'ACTION_LABEL_VIEW_LESS',
  ACTION_LABEL_YOUR_CHANGES = 'ACTION_LABEL_YOUR_CHANGES',
  ACTION_UPGRADE_YOUR_TRUCK = 'ACTION_UPGRADE_YOUR_TRUCK',
  ACTION_UPLOAD = 'ACTION_UPLOAD',
  ACTION_UPLOAD_CONFIG = 'ACTION_UPLOAD_CONFIG',
  BANNER_HEADER = 'BANNER_HEADER',
  BANNER_SUBHEADER = 'BANNER_SUBHEADER',
  BANNER_TEXT = 'BANNER_TEXT',
  BEV_CAMPAIGN_LINK_TEXT = 'BEV_CAMPAIGN_LINK_TEXT',
  BEV_LINK = 'BEV_LINK',
  BODYBUILD_LABEL = 'BODYBUILD_LABEL',
  CAMPAIGN_LINK_TEXT = 'CAMPAIGN_LINK_TEXT',
  CAMPAIGN_LINK_URL = 'CAMPAIGN_LINK_URL',
  CAMPAIGN_SHORT_TEXT = 'CAMPAIGN_SHORT_TEXT',
  CAMPAIGN_SMART_DASH_NAME = 'CAMPAIGN_SMART_DASH_NAME',
  CAMPAIGN_SMART_DASH_TEXT = 'CAMPAIGN_SMART_DASH_TEXT',
  COC_CLICK_HERE = 'COC_CLICK_HERE',
  COC_VIEW_ALL_TEXT = 'COC_VIEW_ALL_TEXT',
  COC_VIEW_LESS_TEXT = 'COC_VIEW_LESS_TEXT',
  DESCRIPTION_ALL_PRODUCT_SELECTIONS = 'DESCRIPTION_ALL_PRODUCT_SELECTIONS',
  DESCRIPTION_COC = 'DESCRIPTION_COC',
  DESCRIPTION_COC_LOADED_TRUCK = 'DESCRIPTION_COC_LOADED_TRUCK',
  DESCRIPTION_GUIDED_VIEW = 'DESCRIPTION_GUIDED_VIEW',
  DESCRIPTION_LOSING_CHANGES = 'DESCRIPTION_LOSING_CHANGES',
  DESCRIPTION_OVERVIEW = 'DESCRIPTION_OVERVIEW',
  DESCRIPTION_PASSWORD_RESET_FAILURE = 'DESCRIPTION_PASSWORD_RESET_FAILURE',
  DESCRIPTION_REQUEST_SENT = 'DESCRIPTION_REQUEST_SENT',
  DESCRIPTION_RESET_EMAIL_SENT = 'DESCRIPTION_RESET_EMAIL_SENT',
  DESCRIPTION_SHARE_EMAIL_SENT = 'DESCRIPTION_SHARE_EMAIL_SENT',
  DESCRIPTION_SUMMARY = 'DESCRIPTION_SUMMARY',
  DESCRIPTION_UPGRADE_YOUR_FLEET = 'DESCRIPTION_UPGRADE_YOUR_FLEET',
  DESCRIPTION_UPGRADE_YOUR_FLEET_FM = 'DESCRIPTION_UPGRADE_YOUR_FLEET_FM',
  DESCRIPTION_VIEW_ALL = 'DESCRIPTION_VIEW_ALL',
  DESCRIPTION_VIEW_INFORMATION = 'DESCRIPTION_VIEW_INFORMATION',
  DESCRIPTION_WAIT = 'DESCRIPTION_WAIT',
  DESCRIPTION_XML_UPLOAD = 'DESCRIPTION_XML_UPLOAD',
  DESIGN_UPDATE_DISCLAIMER_HEADER = 'DESIGN_UPDATE_DISCLAIMER_HEADER',
  DESIGN_UPDATE_DISCLAIMER_TEXT = 'DESIGN_UPDATE_DISCLAIMER_TEXT',
  ERROR_CUSTOMER_EXTENDED_CHECK = 'ERROR_CUSTOMER_EXTENDED_CHECK',
  ERROR_FATAL = 'ERROR_FATAL',
  ERROR_FRIENDLY_SERVER_DISCONNECTED = 'ERROR_FRIENDLY_SERVER_DISCONNECTED',
  ERROR_REGISTRATION_UNAVAILABLE = 'ERROR_REGISTRATION_UNAVAILABLE',
  ERROR_REQUEST_FAILED = 'ERROR_REQUEST_FAILED',
  ERROR_SECM_CHANGE_STEP_V2 = 'ERROR_SECM_CHANGE_STEP_V2',
  ERROR_SERVER_COMMUNICATION_BREAKDOWN = 'ERROR_SERVER_COMMUNICATION_BREAKDOWN',
  ERROR_SERVICE_UNAVAILABLE = 'ERROR_SERVICE_UNAVAILABLE',
  ERROR_SESSION = 'ERROR_SESSION',
  ERROR_TRUCK_NAME = 'ERROR_TRUCK_NAME',
  ERROR_TRY_LATER = 'ERROR_TRY_LATER',
  ERROR_WRONG_MARKET = 'ERROR_WRONG_MARKET',
  ERROR_XML_BAD_FORMAT = 'ERROR_XML_BAD_FORMAT',
  ERROR_XML_MANDATORY = 'ERROR_XML_MANDATORY',
  ERROR_XML_NO_FILE_SELECTED = 'ERROR_XML_NO_FILE_SELECTED',
  EYS_SEND_CHANGES_BUTTON = 'EYS_SEND_CHANGES_BUTTON',
  EYS_SEND_CHANGES_CONFIRMATION_HEADER = 'EYS_SEND_CHANGES_CONFIRMATION_HEADER',
  EYS_SEND_CHANGES_CONFIRMATION_TEXT = 'EYS_SEND_CHANGES_CONFIRMATION_TEXT',
  EYS_SEND_CHANGES_SALES_HEADER = 'EYS_SEND_CHANGES_SALES_HEADER',
  EYS_SEND_CHANGES_TEXT = 'EYS_SEND_CHANGES_TEXT',
  EYS_SHARE_MENU_OTHERS = 'EYS_SHARE_MENU_OTHERS',
  EYS_SHARE_MENU_SALES_REPRESENTATIVE = 'EYS_SHARE_MENU_SALES_REPRESENTATIVE',
  FM_ELECTRIC_TRUCK = 'FM_ELECTRIC_TRUCK',
  FM_GO_TO_GUIDED_OFFERING_INSTEAD = 'FM_GO_TO_GUIDED_OFFERING_INSTEAD',
  FM_MARKETED_RANGE = 'FM_MARKETED_RANGE',
  FM_NO_VISIBLE_FILTERED_TRUCKS = 'FM_NO_VISIBLE_FILTERED_TRUCKS',
  FM_OPEN_SHOWROOM = 'FM_OPEN_SHOWROOM',
  FM_PAGE_TITLE = 'FM_PAGE_TITLE',
  FM_PAGE_TITLE_HEAD = 'FM_PAGE_TITLE_HEAD',
  FM_PAGE_TITLE_TAIL = 'FM_PAGE_TITLE_TAIL',
  FM_PRODUCT_RANGE = 'FM_PRODUCT_RANGE',
  FM_SEE_ALL_IN_OPERATION_BUTTON_TEXT = 'FM_SEE_ALL_IN_OPERATION_BUTTON_TEXT',
  GDPR_CONFIRM_MESSAGE = 'GDPR_CONFIRM_MESSAGE',
  GDPR_CONFIRM_TITLE = 'GDPR_CONFIRM_TITLE',
  GV_SELECTED = 'GV_SELECTED',
  HEADER_COC = 'HEADER_COC',
  HEADER_COC_ADDED = 'HEADER_COC_ADDED',
  HEADER_COC_CHANGES = 'HEADER_COC_CHANGES',
  HEADER_COC_LOADED_TRUCK = 'HEADER_COC_LOADED_TRUCK',
  HEADER_COC_REMOVED = 'HEADER_COC_REMOVED',
  HEADER_COC_TABLE_ADDED = 'HEADER_COC_TABLE_ADDED',
  HEADER_COC_TABLE_OPTION = 'HEADER_COC_TABLE_OPTION',
  HEADER_COC_TABLE_REMOVED = 'HEADER_COC_TABLE_REMOVED',
  HEADER_ENTER_NEW_PASSWORD = 'HEADER_ENTER_NEW_PASSWORD',
  HEADER_ERROR_NOTIFICATION = 'HEADER_ERROR_NOTIFICATION',
  HEADER_ERROR_OCCURD = 'HEADER_ERROR_OCCURD',
  HEADER_GARAGE_IS_EMPTY = 'HEADER_GARAGE_IS_EMPTY',
  HEADER_GV_ALL_PRODUCT_SELECTIONS = 'HEADER_GV_ALL_PRODUCT_SELECTIONS',
  HEADER_GV_CURRENT_CONFIGURATION = 'HEADER_GV_CURRENT_CONFIGURATION',
  HEADER_GV_DESIGN_YOUR = 'HEADER_GV_DESIGN_YOUR',
  HEADER_GV_PACKAGES = 'HEADER_GV_PACKAGES',
  HEADER_GV_PRODUCT_CATEGORIES = 'HEADER_GV_PRODUCT_CATEGORIES',
  HEADER_GV_PRODUCT_OPTIONS = 'HEADER_GV_PRODUCT_OPTIONS',
  HEADER_GV_PRODUCT_TYPE = 'HEADER_GV_PRODUCT_TYPE',
  HEADER_LANDPAGE_BUILD_YOUR_TRUCK = 'HEADER_LANDPAGE_BUILD_YOUR_TRUCK',
  HEADER_LOAD_WARMING_UP = 'HEADER_LOAD_WARMING_UP',
  HEADER_LOGIN_FORM = 'HEADER_LOGIN_FORM',
  HEADER_LOSING_CHANGES = 'HEADER_LOSING_CHANGES',
  HEADER_MANAGE_ACCOUNT = 'HEADER_MANAGE_ACCOUNT',
  HEADER_NEW_PASSWORD = 'HEADER_NEW_PASSWORD',
  HEADER_QR_FORM_COMPANY_INFO = 'HEADER_QR_FORM_COMPANY_INFO',
  HEADER_QR_FORM_USER_INFO = 'HEADER_QR_FORM_USER_INFO',
  HEADER_REGISTRATION_FORM = 'HEADER_REGISTRATION_FORM',
  HEADER_REQUEST_SENT = 'HEADER_REQUEST_SENT',
  HEADER_RESET_EMAIL_SENT = 'HEADER_RESET_EMAIL_SENT',
  HEADER_RESET_PASSWORD = 'HEADER_RESET_PASSWORD',
  HEADER_SPECIFICATION = 'HEADER_SPECIFICATION',
  HEADER_UPGRADE_YOUR_TRUCK = 'HEADER_UPGRADE_YOUR_TRUCK',
  HEADER_WAIT = 'HEADER_WAIT',
  LABEL_ABOUT = 'LABEL_ABOUT',
  LABEL_ACTION_BACKTOLOGGIN = 'LABEL_ACTION_BACKTOLOGGIN',
  LABEL_ACTION_CANCEL = 'LABEL_ACTION_CANCEL',
  LABEL_ACTION_CLOSE = 'LABEL_ACTION_CLOSE',
  LABEL_ACTION_COPY = 'LABEL_ACTION_COPY',
  LABEL_ACTION_DISCARD_CHANGES = 'LABEL_ACTION_DISCARD_CHANGES',
  LABEL_ACTION_GOT_IT = 'LABEL_ACTION_GOT_IT',
  LABEL_ACTION_HIDE = 'LABEL_ACTION_HIDE',
  LABEL_ACTION_LOGIN = 'LABEL_ACTION_LOGIN',
  LABEL_ACTION_LOGOUT = 'LABEL_ACTION_LOGOUT',
  LABEL_ACTION_MAILPASSWORD = 'LABEL_ACTION_MAILPASSWORD',
  LABEL_ACTION_OK = 'LABEL_ACTION_OK',
  LABEL_ACTION_PDF = 'LABEL_ACTION_PDF',
  LABEL_ACTION_PRINT = 'LABEL_ACTION_PRINT',
  LABEL_ACTION_REGISTER_ACCOUNT = 'LABEL_ACTION_REGISTER_ACCOUNT',
  LABEL_ACTION_RELOAD_APP = 'LABEL_ACTION_RELOAD_APP',
  LABEL_ACTION_REQUEST_OFFER = 'LABEL_ACTION_REQUEST_OFFER',
  LABEL_ACTION_SAVE = 'LABEL_ACTION_SAVE',
  LABEL_ACTION_SAVE_AS = 'LABEL_ACTION_SAVE_AS',
  LABEL_ACTION_SAVE_XML = 'LABEL_ACTION_SAVE_XML',
  LABEL_ACTION_SHARE = 'LABEL_ACTION_SHARE',
  LABEL_ACTION_SHARE_FACEBOOK = 'LABEL_ACTION_SHARE_FACEBOOK',
  LABEL_ACTION_SHARE_LINK = 'LABEL_ACTION_SHARE_LINK',
  LABEL_ACTION_SHARE_WHATSAPP = 'LABEL_ACTION_SHARE_WHATSAPP',
  LABEL_ACTION_SHOW = 'LABEL_ACTION_SHOW',
  LABEL_ACTION_SUBMIT_REGISTRATION = 'LABEL_ACTION_SUBMIT_REGISTRATION',
  LABEL_ACTION_SUMMARY = 'LABEL_ACTION_SUMMARY',
  LABEL_ADDRESS_CITY = 'LABEL_ADDRESS_CITY',
  LABEL_ADDRESS_POSTAL_CODE = 'LABEL_ADDRESS_POSTAL_CODE',
  LABEL_COLOR_02575 = 'LABEL_COLOR_02575',
  LABEL_COLOR_06482 = 'LABEL_COLOR_06482',
  LABEL_COLOR_06483 = 'LABEL_COLOR_06483',
  LABEL_COLOR_06484 = 'LABEL_COLOR_06484',
  LABEL_COLOR_06485 = 'LABEL_COLOR_06485',
  LABEL_COLOR_06486 = 'LABEL_COLOR_06486',
  LABEL_COLOR_06487 = 'LABEL_COLOR_06487',
  LABEL_COLOR_06488 = 'LABEL_COLOR_06488',
  LABEL_COLOR_06489 = 'LABEL_COLOR_06489',
  LABEL_COLOR_06490 = 'LABEL_COLOR_06490',
  LABEL_COLOR_06491 = 'LABEL_COLOR_06491',
  LABEL_COLOR_06492 = 'LABEL_COLOR_06492',
  LABEL_COLOR_CAB = 'LABEL_COLOR_CAB',
  LABEL_COMMENTS = 'LABEL_COMMENTS',
  LABEL_COMPANY_NAME = 'LABEL_COMPANY_NAME',
  LABEL_CURRENT_SELECTION = 'LABEL_CURRENT_SELECTION',
  LABEL_DELETE_TRUCK = 'LABEL_DELETE_TRUCK',
  LABEL_DETAILS = 'LABEL_DETAILS',
  LABEL_EMAIL = 'LABEL_EMAIL',
  LABEL_FIRST_NAME = 'LABEL_FIRST_NAME',
  LABEL_FORGOTTEN_PASSWORD = 'LABEL_FORGOTTEN_PASSWORD',
  LABEL_GARAGE = 'LABEL_GARAGE',
  LABEL_INVALID_ADDRESS_POSTAL_CODE = 'LABEL_INVALID_ADDRESS_POSTAL_CODE',
  LABEL_INVALID_COMPANY_NAME = 'LABEL_INVALID_COMPANY_NAME',
  LABEL_INVALID_EMAIL = 'LABEL_INVALID_EMAIL',
  LABEL_INVALID_FORM_INPUT = 'LABEL_INVALID_FORM_INPUT',
  LABEL_INVALID_RESELLER = 'LABEL_INVALID_RESELLER',
  LABEL_INVALID_VAT_NUMBER = 'LABEL_INVALID_VAT_NUMBER',
  LABEL_ITEM = 'LABEL_ITEM',
  LABEL_LAST_NAME = 'LABEL_LAST_NAME',
  LABEL_LOAD_TRUCK = 'LABEL_LOAD_TRUCK',
  LABEL_NAME = 'LABEL_NAME',
  LABEL_NO_SELECTION = 'LABEL_NO_SELECTION',
  LABEL_ORGANIZATION_NUMBER = 'LABEL_ORGANIZATION_NUMBER',
  LABEL_PASSWORD = 'LABEL_PASSWORD',
  LABEL_PASSWORD_REPEAT = 'LABEL_PASSWORD_REPEAT',
  LABEL_PERSONAL_MESSAGE = 'LABEL_PERSONAL_MESSAGE',
  LABEL_PHONE_NUMBER = 'LABEL_PHONE_NUMBER',
  LABEL_QR_CODE = 'LABEL_QR_CODE',
  LABEL_READ_MORE = 'LABEL_READ_MORE',
  LABEL_SELECTION = 'LABEL_SELECTION',
  LABEL_SHARE_RECIPIENT = 'LABEL_SHARE_RECIPIENT',
  LABEL_SHARE_SENDER = 'LABEL_SHARE_SENDER',
  LABEL_SHOW_ALL = 'LABEL_SHOW_ALL',
  LABEL_TERMS_AND_CONDITIONS = 'LABEL_TERMS_AND_CONDITIONS',
  LABEL_TRUCK_NAME = 'LABEL_TRUCK_NAME',
  LABEL_USER_NOT_REGISTERED = 'LABEL_USER_NOT_REGISTERED',
  LABEL_VAT_NUMBER = 'LABEL_VAT_NUMBER',
  LABEL_VIEW_INTERIOR = 'LABEL_VIEW_INTERIOR',
  LANDING_PAGE_SUBHEADER_BEV = 'LANDING_PAGE_SUBHEADER_BEV',
  LANDING_PAGE_TEXT_BEV = 'LANDING_PAGE_TEXT_BEV',
  LANDING_PAGE_TEXT_COMPLETE = 'LANDING_PAGE_TEXT_COMPLETE',
  LINK_DISCLAIMER = 'LINK_DISCLAIMER',
  LINK_LEGAL = 'LINK_LEGAL',
  LINK_TEXT_DISCLAIMER = 'LINK_TEXT_DISCLAIMER',
  LINK_UPGRADE_YOUR_FLEET = 'LINK_UPGRADE_YOUR_FLEET',
  LINK_WORD_MARK = 'LINK_WORD_MARK',
  LOADING = 'LOADING',
  MARKET = 'MARKET',
  NOTIFICATION_BAD_EMAIL = 'NOTIFICATION_BAD_EMAIL',
  NOTIFICATION_BAD_MAIL_PASSWORD = 'NOTIFICATION_BAD_MAIL_PASSWORD',
  NOTIFICATION_NEED_ACCEPT_TERMS = 'NOTIFICATION_NEED_ACCEPT_TERMS',
  NOTIFICATION_PASSWORDS_DONT_MATCH = 'NOTIFICATION_PASSWORDS_DONT_MATCH',
  PHONE_NUMBER_INSTRUCTIONS = 'PHONE_NUMBER_INSTRUCTIONS',
  RFQ1_COMMENT_PLACEHOLDER = 'RFQ1_COMMENT_PLACEHOLDER',
  RFQ1_CONTACT = 'RFQ1_CONTACT',
  RFQ1_CONTACT_SHORT = 'RFQ1_CONTACT_SHORT',
  RFQ1_CUSTOMER_ROLE_DRIVER = 'RFQ1_CUSTOMER_ROLE_DRIVER',
  RFQ1_CUSTOMER_ROLE_OTHER = 'RFQ1_CUSTOMER_ROLE_OTHER',
  RFQ1_CUSTOMER_ROLE_OWNER = 'RFQ1_CUSTOMER_ROLE_OWNER',
  RFQ1_FINANCE_DESCRIPTION = 'RFQ1_FINANCE_DESCRIPTION',
  RFQ1_INFORMATION = 'RFQ1_INFORMATION',
  RFQ1_INFORMATION_SHORT = 'RFQ1_INFORMATION_SHORT',
  RFQ1_I_DONT_KNOW_DEALER = 'RFQ1_I_DONT_KNOW_DEALER',
  RFQ1_MARKETING_CONSENT = 'RFQ1_MARKETING_CONSENT',
  RFQ1_NEWSLETTER = 'RFQ1_NEWSLETTER',
  RFQ1_NEWSLETTER_DESCRIPTION = 'RFQ1_NEWSLETTER_DESCRIPTION',
  RFQ1_PERSONEL_DATA = 'RFQ1_PERSONEL_DATA',
  RFQ1_PERSONEL_DATA_DESCRIPTION1 = 'RFQ1_PERSONEL_DATA_DESCRIPTION1',
  RFQ1_PERSONEL_DATA_DESCRIPTION2 = 'RFQ1_PERSONEL_DATA_DESCRIPTION2',
  RFQ1_RESELLER = 'RFQ1_RESELLER',
  RFQ1_ROLE = 'RFQ1_ROLE',
  RFQ1_SEND = 'RFQ1_SEND',
  RFQ1_SEND_SHORT = 'RFQ1_SEND_SHORT',
  RFQ1_WHAT_HAPPENS_NEXT = 'RFQ1_WHAT_HAPPENS_NEXT',
  SCANIA_COPYRIGHT = 'SCANIA_COPYRIGHT',
  SEARCH = 'SEARCH',
  SEARCH_MIN_LENGTH = 'SEARCH_MIN_LENGTH',
  SEARCH_NO_HITS = 'SEARCH_NO_HITS',
  SIDEPANEL_DESCRIPTION_ACTIVE_CHANGES = 'SIDEPANEL_DESCRIPTION_ACTIVE_CHANGES',
  SIDEPANEL_DESCRIPTION_SAVE = 'SIDEPANEL_DESCRIPTION_SAVE',
  SIDEPANEL_DESCRIPTION_SAVE_GARAGE = 'SIDEPANEL_DESCRIPTION_SAVE_GARAGE',
  SIDEPANEL_DESCRIPTION_SAVE_IMAGE = 'SIDEPANEL_DESCRIPTION_SAVE_IMAGE',
  SIDEPANEL_DESCRIPTION_SAVE_PDF = 'SIDEPANEL_DESCRIPTION_SAVE_PDF',
  SIDEPANEL_DESCRIPTION_SAVE_QR = 'SIDEPANEL_DESCRIPTION_SAVE_QR',
  SIDEPANEL_DESCRIPTION_SAVE_XML = 'SIDEPANEL_DESCRIPTION_SAVE_XML',
  SIDEPANEL_DESCRIPTION_SHARE = 'SIDEPANEL_DESCRIPTION_SHARE',
  SIDEPANEL_DESCRIPTION_SHARE_EMAIL = 'SIDEPANEL_DESCRIPTION_SHARE_EMAIL',
  SIDEPANEL_DESCRIPTION_SHARE_FACEBOOK = 'SIDEPANEL_DESCRIPTION_SHARE_FACEBOOK',
  SIDEPANEL_DESCRIPTION_SHARE_LINK = 'SIDEPANEL_DESCRIPTION_SHARE_LINK',
  SIDEPANEL_DESCRIPTION_SHARE_WHATSAPP = 'SIDEPANEL_DESCRIPTION_SHARE_WHATSAPP',
  SIDEPANEL_SUBHEADER_EMAIL = 'SIDEPANEL_SUBHEADER_EMAIL',
  SIDEPANEL_SUBHEADER_FACEBOOK = 'SIDEPANEL_SUBHEADER_FACEBOOK',
  SIDEPANEL_SUBHEADER_PICTURE = 'SIDEPANEL_SUBHEADER_PICTURE',
  SKIP_TO_BUILD_MODE_CONFIG_ID = 'SKIP_TO_BUILD_MODE_CONFIG_ID',
  STARTUP_GET_STARTED = 'STARTUP_GET_STARTED',
  STARTUP_LOADING = 'STARTUP_LOADING',
  TEXT_GARAGE_IS_EMPTY = 'TEXT_GARAGE_IS_EMPTY',
  TEXT_MANAGE_ACCOUNT = 'TEXT_MANAGE_ACCOUNT',
  TEXT_TERMS_AND_CONDITIONS = 'TEXT_TERMS_AND_CONDITIONS',
  WARNING_LEAVING_PAGE = 'WARNING_LEAVING_PAGE',
  WINDOW_DESCRIPTION = 'WINDOW_DESCRIPTION',
  WINDOW_KEYWORDS = 'WINDOW_KEYWORDS',
  WINDOW_TITLE = 'WINDOW_TITLE',
}

/**
 * By using this the localization returns empty string instead of crashing.
 *
 * import useTexts from '../../utils/useTexts';
 *
 * usage:
 * const t = useTexts(); // returns a function.
 *
 * In jsx:
 * <div>{t('MY_SYMBOL_KEY')}</div>
 *
 * Getting varible depending symbols, filtering out characters we can't use in symbol keys.
 * <div>{t('MY_SYMBOL_KEY_', my_id_variable)}</div>
 * in case my_id_variable is '1234~AB' the resulting symbol key is 'MY_SYMBOL_KEY_1234AB'.
 *
 * If the symbol is missing t() returns empty string.
 * Unless ?debug=texts is present in url, then 'Missing symbol' is returned.
 *
 * Symbols kan contain placeholders in the format of '{1}'.
 * The number represents index of the third argument (array).
 * All occurences matching placeholder given index will be replaced with the variable in the array with matching index.
 * Example:
 * Symbol: MY_TEST_SYMBOL = 'Snowwhite and the {0} dwarfs.'
 * const numberOfDwarfs = 'seven';
 * t(MY_TEST_SYMBOL, null, [numberOfDwarfs])
 * Yields 'Snowwhite and the seven dwarfs.'
 */

const temp: Record<string, string> = {
  //  FM_PAGE_TITLE: 'Digital showroom',
  //  FM_FILTER_SHOW_ALL: 'All',
  //  FM_GO_TO_GUIDED_OFFERING_INSTEAD: 'Build your own truck'
  //  FM_SEE_ALL_IN_OPERATION_BUTTON_TEXT: 'See all in {}'
}

export type TextGetter = (
  key: string,
  id?: string,
  replaceArr?: string[],
) => string

// TODO: Remove and replace with useTextsV2 everywhere.
function useTexts(): TextGetter {
  const textsObj = useAppSelector(getTextsState)
  const texts = useCallback<TextGetter>(
    (key: string, id?: string, replaceArr?: string[]) => {
      if (id) {
        key = key + id.toString().replace(/[\W]+/, '')
      }
      const missingSymbolReplacment = ''
      let t = textsObj || {}
      let localizedText = t[key] || temp[key] || missingSymbolReplacment
      // localizedText = localizedText.replace(/\n/g, returnJSXbr());
      if (replaceArr && /\{[0-9]+\}/g.test(localizedText)) {
        replaceArr.forEach((replacement_text, i) => {
          const regex = new RegExp('\\{' + i + '\\}', 'g')
          new RegExp('\\{' + i + '\\}', 'g')
          localizedText = localizedText.replace(regex, replacement_text)
        })
      }
      return localizedText
    },
    [textsObj],
  )

  // IMPORTANT:
  // This must be a memoized callback from useCallback to allow using the
  // returned TextGetter in React hook dependency lists, or there will be
  // infinite React render loops!
  return texts
}

export type TextGetterV2 = (id: TextId) => string

/** TODO: Replace the original one everywhere. */
export function useTextsV2(): TextGetterV2 {
  const textsInRedux = useAppSelector(getTextsState)
  return useCallback<TextGetterV2>(
    (id) => {
      // A temporary way to check if texts are initialized, without causing
      // massive code changes.
      //
      // TODO: Make useTextsV2 return TextGetterV2 | null
      if (textsInRedux && id === TextId.__TEXTS_ARE_INITIALIZED__) {
        return TextId.__TEXTS_ARE_INITIALIZED__
      }

      let texts = textsInRedux || {}
      const text = texts[id]
      return text === null || text === undefined ? '' : text
    },
    [textsInRedux],
  )
}

export default useTexts
